import ThothV2 from '../base/thothV2';

export default class TransactionMonitoringService extends ThothV2 {
    baseUrl = '/monitoring'
}
